module.exports = __webpack_public_path__ + "img/mche-lee-PC91Jm1DlWA-unsplash.1416a46c.jpg";